import gigfortList from '../images/projects/gigfort-list.jpg'
import gigfortMap from '../images/projects/gigfort-map.jpg'

const projects = [
    {
        id: 'gig-fort',
        name: 'Gig Fort',
        tagline: 'A live music gig guide for Wellington',
        description: "A live music gig guide app for Wellington. The idea was to create a comprehensive, centralised gig listing with a clear UI/UX - a one-stop shop for Wellington gigs with a fast time to discovery. Browse today's or this week's gigs by day, filter by genre, search, or switch to the map view to see what's on around town. The first release was built pre-AI.",
        tech: ['Expo', 'React Native', 'Firebase'],
        website: '',
        repo: '',
        cover: gigfortList,
        screenshots: [gigfortList, gigfortMap]
    }
]

export default projects
